//------------------------
// process tag containers
//------------------------
export default function processTagContainers({ container_id, character_items }) {
  console.log('--------------------------------------')
  console.log('IN processTagContainers')
  console.log('container_id = ', container_id)
  //----------------------------
  // initialise container queue
  //----------------------------
  let tag_containers = []
  let containerQueue = []
  containerQueue.push(container_id)
  //=====================================
  // LOOP CONTAINERS
  //=====================================
  do {
    //-------------------------------
    // get next container to process
    //-------------------------------
    let this_container = containerQueue.shift()
    //----------------------
    // get container object
    //----------------------
    const container_item = character_items.find((ci) => ci.id === this_container)
    //---------------------
    // check got container
    //---------------------
    if (container_item) {
      tag_containers.push(this_container)
      console.log(
        'tagged container to have contents enc/cnt calculated in main process= ',
        container_item,
      )
      //------------------------------------------------------------
      // check if this container is itself contained - add to queue
      //------------------------------------------------------------
      if (container_item.container) {
        containerQueue.push(container_item.container)
        console.log('this container is itself in a container = ', container_item.container)
      }
      //-------------------------------------------------
    } else {
      console.error('container item not found in character items for id = ', this_container)
    }
    //-------------------------------------------------
  } while (containerQueue.length > 0)
  //=====================================
  // END LOOP
  //=====================================
  //---------
  // returns
  //---------
  console.log('completed processTagContainers')
  return tag_containers
}
